export const DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION =
  'DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION';

export const INITIALIZE_DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION =
  'INITIALIZE_DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION';

export const dateRangeFilterDataAccessException = fromDate => dispatch => {
  dispatch({
    type: DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION,
    payload: fromDate,
  });
};

export const initializeDateRangeFilterDataAccessException = () => dispatch => {
  dispatch({
    type: INITIALIZE_DATE_RANGE_FILTER_DATA_ACCESS_EXCEPTION,
  });
};
